// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__ZgwGg","tab":"Tabs_tab__3-KZv","tabActive":"Tabs_tabActive__2AyoF"};